import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'
import Icon from "../common/icon/icon.component.jsx"

class QuoteItemStatusBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            status: this.props.status
        }
        this.className = this.props.className || ''
        this.customStyle = this.props.style || {}
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            status: nextProps.status
        })
    }

    renderStatus() {
        switch (this.state.status) {
            case 'option-for-customer':
                return <div className="badge badge-secondary text-with-icon">
                    <FormattedMessage
                        id="quote.item.status.option_for_customer_label"c
                        defaultMessage="Optional Item"
                    />
                </div>
            case 'chosen-by-customer':
                return <div className="badge badge-success text-with-icon">
                    <FormattedMessage
                        id="quote.item.status.chosen_by_customer_label"
                        defaultMessage="Chosen by customer"
                    />
                </div>
            case 'multiple-choice':
                return <div className="badge badge-info text-with-icon">
                    <FormattedMessage
                        id="quote.item.status.multiple_choice_label"
                        defaultMessage="Multiple choice"
                    />
                </div>
            case 'choice-selected':
                return <div className="badge badge-info text-with-icon">
                    <i className="fas fa-check-circle mr-1"/>
                    <FormattedMessage
                        id="quote.item.status.choice_selected_label"
                        defaultMessage="Choice Selected"
                    />
                </div>
            case 'provided-by-customer':
                return <div className="badge badge-info text-with-icon">
                    <FormattedMessage
                        id="quote.item.status.provided_by_customer_label"
                        defaultMessage="Provided by customer"
                    />
                </div>
            case 'included':
                return <div className="badge badge-primary text-with-icon">
                    <FormattedMessage
                        id="quote.item.status.included_label"
                        defaultMessage="Included"
                    />
                </div>
        }
        return ''
    }

    render() {
        const status = this.renderStatus()
        if (!status) {
            return null
        }
        return <span className={this.className} style={this.customStyle}>
            {status}
        </span>
    }

}

export default QuoteItemStatusBadge





// WEBPACK FOOTER //
// ./src/quote/itemstatus.component.jsx